import { docTypes, formModes, alfrescoTypes } from './constants';
export const documentsRoutes = [
    {
        type: docTypes.contract,
        baseUrl: "contract",
        parentUrl: "/documents/docs/",
        modes: [formModes.create, formModes.read, formModes.edit],
        alfrescoType: alfrescoTypes.forwarderContract,
        prop_sx_documentType: "8"
    },
    {
        type: docTypes.request,
        baseUrl: "request",
        modes: [formModes.create, formModes.read, formModes.edit],
        parentUrl: "/documents/request/",
        alfrescoType: alfrescoTypes.counterpartyAccreditationCard,
        prop_sx_documentType: "4"
    },
    {
        type: docTypes.simplerequest,
        baseUrl: "simplerequest",
        modes: [formModes.create, formModes.read, formModes.edit],
        parentUrl: "/documents/request/",
        alfrescoType: alfrescoTypes.simpleCounterpartyAccreditationCard,
        prop_sx_documentType: "10"
    },
    {
        type: docTypes.sourcedocument,
        baseUrl: "outgoingdocument",
        parentUrl: "/documents/docs/",
        modes: [formModes.create, formModes.read, formModes.edit],
        alfrescoType: alfrescoTypes.incomingDocument,
        prop_sx_documentType: "7"
    },
    {
        type: docTypes.outgoingDocument,
        baseUrl: "incomingdocument",
        parentUrl: "/documents/docs/",
        modes: [formModes.read],
        alfrescoType: alfrescoTypes.outgoingDocument,
        prop_sx_documentType: "5"
    },
    {
        type: docTypes.certificate,
        baseUrl: "ISCCEUCertificate",
        parentUrl: "/documents/docs/",
        modes: [formModes.create, formModes.read, formModes.edit],
        alfrescoType: alfrescoTypes.certificate,
        prop_sx_documentType: "11"
    }
]